import React, { useEffect, useState } from "react";
import { Box, Button, MenuItem, TextField } from "@material-ui/core";
import { useHistory, Link as RouterLink } from "react-router-dom";
import { BaseItemState, OverviewCriteria } from "../Ticker2/Ticker2Models";
import FixtureOverviewUtil from "./FixtureOverviewUtil";
import CreateRoundUtil from "../CreateRound/CreateRoundUtil";
import RoundOverviewUtil from "../RoundOverview/RoundOverviewUtil";
import Ticker2Util from "../Ticker2/Ticker2Util";
import FixtureNgTable from "./FixtureNgTable";
import { ActionState, FixtureNgItem, ExtFixtureFilter, FixtureNg } from "./FixtureOverviewModels";
import { Fixture } from "../TeamOverview/TeamOverviewModels";
import { League } from "../LeagueOverview/LeagueModels";
import { GenericResponse, LeagueListItem } from "../CreateRound/CreateRoundModels";
import { ListResponse } from "../api/ApiNgModels";
import { UpdateItemState } from "../CreateSyndicate/CreateSyndicateModels";
import { blue } from "@material-ui/core/colors";
import ConfirmationDialog from "../Components/ConfirmationDialog";
import { RoundOverviewItem } from "../RoundOverview/RoundOverviewModels";
import MapFixtureToFixtureNgDialog from "./MapFixtureToFixtureNgDialog";


interface FixtureNgItemState extends BaseItemState<FixtureNgItem, number> {
    fixtureId: number;
    leagueId: number;
}
type FixtureNgFilter = "Fixture" | "League";
const fixtureNgFilters : FixtureNgFilter[] = ["Fixture", "League"];

interface FixtureNgViewState {
    filter: FixtureNgFilter;
}
interface MapFixtureState extends UpdateItemState<FixtureNgItem> {
    fixture?: Fixture
}
interface FixtureNgViewProps {
    fixture?: Fixture;
    league?: LeagueListItem;
    // round?: RoundOverviewItem;
    criteria?: OverviewCriteria;
}
const FixtureNgView: React.FC<FixtureNgViewProps> = (props) => {
    var propsFixtureId = 0;
    var propsFixtureNme = "";
    var propsLeagueId = 0;
    // var propsRoundId = 0;
    if (props.fixture) {
        propsFixtureId = props.fixture.id;
        propsFixtureNme = props.fixture.name;
    }
    if (props.fixture) {
        propsLeagueId = props.fixture.leagueId;
    } else if (props.league) {
        propsLeagueId = parseInt(props.league.id);
    }
    // if (props.round) {
    //     propsRoundId = props.round.id;
    // }
    var criteria = props.criteria ? props.criteria : {
        pageSize: 100,
        from:  CreateRoundUtil.getDateWithoutTime(new Date()),
        to: CreateRoundUtil.getDateWithoutTime(CreateRoundUtil.addDays(new Date(), 14)),
        createNo: 1
    };
    const [formState, setFormState] = useState<FixtureNgViewState>({
        filter: "League"
    });
    const [itemState, setItemState] = useState<FixtureNgItemState>({
        fixtureId: propsFixtureId,
        leagueId: propsLeagueId,
        items: [],
        more: false,
        lastId: 0,
        refreshing: false

    });
    const [actionState, setActionState] = useState<ActionState>(FixtureOverviewUtil.createEmptyActionState());
    const [mapFixtureState, setMapFixtureState] = useState<MapFixtureState>({
        method: 'none',
        item: undefined,
        handled: false,
        updateNo: 0,
        version: 0
    });
    const [selectedItem, setSelectedItem] = useState<FixtureNgItem | undefined>(undefined);
    const history = useHistory();   

    var filterFixtureId = propsFixtureId;
    if (formState.filter !== "Fixture") {
        filterFixtureId = 0;
    }

    useEffect(() => {
        refreshItems("Init");
    }, []);

    const handleChange = (name: string, value:any) =>{
        var fs = {...formState, [name]: value};
        //heckFormState(fs);
        setFormState(fs);
    }
    const onSelect = (item : FixtureNgItem) => {
        setSelectedItem(item);
    };

    const getFixtureNgs = async (lastId: number): Promise<GenericResponse<ListResponse<FixtureNgItem>>> => {
        var filter : ExtFixtureFilter = {
            providerId: ""
        }
        var pageSize = 100;
        if (filterFixtureId <= 0) {
            var pageSize = criteria.pageSize;
            var from : Date = criteria.from;
            var to : Date = criteria.to;
            filter.leagueId = propsLeagueId;
            //filter.roundId = propsRoundId;
            return await FixtureOverviewUtil.getFixtureNgItems(pageSize, from, to, lastId, filter);
        }
        filter.fixtureId = filterFixtureId;
        return await FixtureOverviewUtil.getFixtureNgItems(pageSize, undefined, undefined, lastId, filter);
    };
    const refreshItems = (caller: string) => {
        if (itemState.refreshing) {
            return;
        }
        var ast = FixtureOverviewUtil.createEmptyActionState();
        var rs : FixtureNgItemState = {
            fixtureId: propsFixtureId,
            leagueId: propsLeagueId,
            items: [],
            more: false,
            lastId: 0,
            refreshing: false
        }
        var lastId = caller === "onMore" ? itemState.lastId : 0;
        if (lastId > 0) {
            rs.items = itemState.items;
        }
        var success = false;
        itemState.refreshing = true;
        setActionState(FixtureOverviewUtil.createActionState(true, false, `RefreshItems(${caller})...`));
        getFixtureNgs(lastId).then( resp => {
            if (!resp.success) {
                //setActionError(`${caller} error: ${resp.message}`);
                ast.error = true;
                ast.message = `RefreshItems(${caller}) error: ${resp.message}`;
                return;
            }
            var listResponse = resp.item;
            if (listResponse) {
                if (listResponse.items) {
                    if (lastId > 0) {
                        for (const item of listResponse.items) {
                            rs.items.push(item);
                        }
                    } else {
                        rs.items = listResponse.items;
                    }
                    if (listResponse.items.length > 0) {
                        rs.lastId = listResponse.items[listResponse.items.length - 1].id;
                    }
                    if (listResponse.pageSize > 0 && listResponse.pageSize <= listResponse.items.length) {
                        rs.more = true;
                    }
                }           
            }
            success = true;
        }).catch( error => {
            //setActionError(CreateRoundUtil.getExceptionMessage(error, false, `${caller} error`));
            ast.error = true;
            ast.message = CreateRoundUtil.getExceptionMessage(error, false, `RefreshItems(${caller}) error`);
        }).finally( () => {
            if (success || lastId <= 0) {
                setItemState(rs);
            }
            itemState.refreshing = false;
            setActionState(ast);
        });
    };
    const onRefreshItems = () => {
        refreshItems("Refresh");
    };
    const onMore = () : void => {
        if (itemState.lastId <= 0) {
            //setActionError("More failure: LastId was not set");
            setActionState(FixtureOverviewUtil.createActionState(false, true, "More failure: LastId was not set."));
            return;
        }
        refreshItems("onMore");
    }
    const onMap = () => {
        if (!props.fixture) {
            setActionState(FixtureOverviewUtil.createActionState(false, true, "Fixture is not selected."));
            return;
        }
        if (!selectedItem) {
            setActionState(FixtureOverviewUtil.createActionState(false, true, "FixtureNg is not selected."));
            return;
        }
        if (selectedItem.fixtureId && selectedItem.fixtureId > 0) {
            setActionState(FixtureOverviewUtil.createActionState(false, true, "FixtureNg is already mapped."));
            return;
        }
        setMapFixtureState({
            method: 'add',
            item: selectedItem,
            handled: false,
            updateNo: 0,
            version: 0,
            fixture: props.fixture
        });
    };
    const onUnmapItem = (item: FixtureNgItem) => {
        if (!item) {
            setActionState(FixtureOverviewUtil.createActionState(false, true, "FixtureNg is not specified."));
            return;
        }
        if (!item.fixtureId || item.fixtureId <= 0) {
            setActionState(FixtureOverviewUtil.createActionState(false, true, "FixtureNg is not mapped."));
            return;
        }
        setMapFixtureState({
            method: 'remove',
            item: item,
            handled: false,
            updateNo: 0,
            version: 0
        });
    };
    const unmapFixtureNg = (item: FixtureNgItem) => {
        var ast = FixtureOverviewUtil.createEmptyActionState(); 
        setActionState(FixtureOverviewUtil.createActionState(true, false, "Unmapping FixtureNg..."));
        var finished = false;
        FixtureOverviewUtil.unmapFixtureNgFixture(item.id).then((resp) => {
            if (!resp.success) {
                ast.error = true;
                ast.message = `Unmap FixtureNg error: ${resp.message}`;
                return;
            }
            var itemIndex = itemState.items.findIndex(it => it.id === item.id);
            if (itemIndex >= 0) {
                var ist = {...itemState, refreshing: false};
                if (resp.item) {
                    var updateItem = FixtureOverviewUtil.toFixtureNgItem(resp.item);
                    ist.items[itemIndex] = updateItem;
                    setSelectedItem(updateItem);
                }
                setItemState(ist);
            }
        }).catch(error => {
            ast.error = true;
            ast.message = CreateRoundUtil.getExceptionMessage(error, false, "Unmap FixtureNg error");
        }).finally(() => {
            setActionState(ast);
        });
    };

   const onMapFixtureNgClose = (fixtureNg: FixtureNg | undefined) : void => {
        var ms = {...mapFixtureState, handled: true};
        setMapFixtureState(ms);
        if (!fixtureNg) {
            return;
        }
        var fixtureNgItem = FixtureOverviewUtil.toFixtureNgItem(fixtureNg);
        var itemIndex = itemState.items.findIndex(it => it.id === fixtureNg.id);
        if (itemIndex >= 0) {
            itemState.items[itemIndex] = fixtureNgItem;
            setSelectedItem(fixtureNgItem);
        } else {
            if (selectedItem) {
                setSelectedItem(undefined);
            }
        }
      
    };
    const onUnmapFixtureClose = (confirmed: boolean | undefined) : void => {
        if (mapFixtureState.handled) {
            return;
        }
        var ms = {...mapFixtureState, handled: true};
        setMapFixtureState(ms);
        if (!confirmed || !ms.item) {
            return;
        }
        unmapFixtureNg(ms.item);      
    };  
      
    var isExecuting = itemState.refreshing || actionState.executing;
    var actionBox = null;
    if ((actionState.executing || actionState.error) && actionState.message.length > 0) {
        actionBox = (
            <Box color={actionState.error ? RoundOverviewUtil.INVALID_COLOR : blue[500]} fontSize={12}>
                {actionState.message}
            </Box>
        );
    }

    if (!isExecuting && ((itemState.fixtureId !== propsFixtureId && formState.filter === "Fixture")
            || (itemState.leagueId !== propsLeagueId && formState.filter === "League"))) {
        itemState.fixtureId = propsFixtureId;
        itemState.leagueId = propsLeagueId;
        itemState.items = [];
        refreshItems("ChangeLeague");
    }

    var extFixtureInfo = "FixtureNg - Not selected";
    if (selectedItem) {
        extFixtureInfo = `FixtureNg - Id:${selectedItem.id} | Name: ${selectedItem.name} | Starting at: ${CreateRoundUtil.toGameDateString(selectedItem.startingAt)} | Mapped Fixture: ${selectedItem.fixtureId ? selectedItem.fixtureId.toString() : ""}`;
    }

    var info = Ticker2Util.toItemStateString(itemState);
    var moreBtn = null;
    if (itemState.more && !itemState.refreshing) {
        moreBtn = (<Button 
            variant="text"
            color="secondary"
            size="small"
            disabled={isExecuting}
            onClick={e => onMore()}>
            More
        </Button>);
    }


    var mapVisible = props.fixture ? true : false;
    //var mapEnabled = (props.fixture && selectedItem && (!selectedItem.mappingId || selectedItem.mappingId === 0));
    var mapEnabled = (props.fixture && selectedItem);

    var mapDialog = null;
    if (mapFixtureState.item && !mapFixtureState.handled) {
        if (mapFixtureState.method === "add") {
            mapDialog = (
                <MapFixtureToFixtureNgDialog open={true} fixture={mapFixtureState.fixture} fixtureNg={mapFixtureState.item.item} timestamp={RoundOverviewUtil.getTimestamp()} onClose={onMapFixtureNgClose} />
            );
        } else if (mapFixtureState.method === "remove") {
            var mapItem = mapFixtureState.item;
            const unmapContent = (
                <Box>
                    Please confirm that you want to unmap fixture <br/>'<b>{mapItem.fixtureName} ({CreateRoundUtil.toGameDateString(mapItem.fixtureStartingAt)})</b>' <br/>to FixtureNg<br/>
                    '<b>{mapItem.name} ({CreateRoundUtil.toGameDateString(mapItem.startingAt)})</b>'<br/> with id<br/><b>{mapItem.id}</b> .
                </Box>
            );
            mapDialog = (
                <ConfirmationDialog open={true} title="Unmap fixture to FixtureNg" message="Please confirm that you want to unmap fixture to FixtureNg." messageElement={unmapContent} onClose={onUnmapFixtureClose} />
            );            
        }
    }
    // if (mapFixtureState.item && !mapFixtureState.handled) {
    //     if (mapFixtureState.method === "add") {
    //         mapDialog = (
    //             <MapFixtureNgDialog open={true} fixture={mapFixtureState.fixture} fixtureNg={mapFixtureState.item.item} timestamp={RoundOverviewUtil.getTimestamp()} onClose={onMapFixtureNgClose} />
    //         );
    //     } else if (mapFixtureState.method === "remove") {
    //         var mapItem = mapFixtureState.item;
    //         const unmapContent = (
    //             <Box>
    //                 Please confirm that you want to unmap fixture <br/>'<b>{mapItem.fixtureName} ({CreateRoundUtil.toGameDateString(mapItem.fixtureStartingAt)})</b>' <br/>from FixtureNg<br/>
    //                 '<b>{mapItem.name} ({CreateRoundUtil.toGameDateString(mapItem.startingAt)})</b>'.
    //             </Box>
    //         );
    //         mapDialog = (
    //             <ConfirmationDialog open={true} title="Unmap fixture" message="Please confirm that you want to unmap FixtureNg." messageElement={unmapContent} onClose={onUnmapFixtureClose} />
    //         );            
    //     }

    // }

    return (
        <div>
               <Box fontSize={10} marginTop={2}>
                 <TextField
                    label="Filter"
                    select
                    name="filter"
                    value={formState.filter}
                    onChange={e => handleChange("filter", e.target.value)}
                    style={{width:200, marginRight:"5px"}}
                >
                    {fixtureNgFilters.map(filt => (
                    <MenuItem key={`filt_${filt}`} value={filt}>
                        {filt}
                    </MenuItem>
                    ))}
                </TextField>
                <Button 
                    variant="contained"
                    color="secondary"
                    size="small"
                    disabled={isExecuting}
                    style={{marginRight: "5px"}}
                    onClick={e => onRefreshItems()}>
                    Search
                </Button>
            </Box>
            <Box fontSize={10} marginTop={2}>
                {extFixtureInfo}
            </Box>
            {mapVisible ? (
            <Box>
                <Button 
                    variant="contained"
                    color="secondary"
                    size="small"
                    disabled={isExecuting || !mapEnabled}
                    style={{marginRight: "5px"}}
                    onClick={e => onMap()}>
                    Map
                </Button>
            </Box>
            ) : null}
            {actionBox}
            <Box fontSize={10}>
                {info}{moreBtn}
            </Box>
            <FixtureNgTable items={itemState.items} onSelect={onSelect} onDelete={onUnmapItem} />
            {mapDialog}
        </div>
    );
};

export default FixtureNgView;

